var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drawItem",class:{
  excl:_vm.exclusive===1,
  focus:_vm.focus,
  removed:_vm.myremoved === 1,
  rolling:_vm.rolling && !_vm.mydrawed ,
  drawed:_vm.mydrawed,
  item_blue:_vm.type==1,
  item_orange:_vm.type==2,
  item_puple:_vm.type==3,
  item_box:_vm.type==4
},on:{"click":_vm.choose}},[_c('div',{staticClass:"drawItemImg"},[_c('img',{attrs:{"src":_vm.img}}),_vm._v(" "),(_vm.num>1)?_c('span',[_vm._v("X "+_vm._s(_vm.num))]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0b4083e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/drawItem.vue
// module id = null
// module chunks = 